import { Reagent } from "../../../backend/src/types";
import { ENDPOINT } from "../endpoint/endpoint";
import { errorMessage } from "../function/errorMessage";

type Response<T> = {
  data: T;
  error?: any;
};

interface GetAlertsListPayload {
  tenant_id: number;
  lab_id: number;
  category: string;
}

export async function getAlertsList<T>(
  payload: GetAlertsListPayload,
): Promise<T[]> {
  try {
    const res = await fetch(ENDPOINT.alert.getAlertsList, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const { data, error }: Response<T[]> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("アラートリストの取得に失敗しました", error);
    return [];
  }
}

interface GetAlertsCountPayload {
  tenant_id: number;
  lab_ids: number[];
}

export async function getAlertsCount(
  payload: GetAlertsCountPayload,
): Promise<number> {
  try {
    const res = await fetch(ENDPOINT.alert.getAlertsCount, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const { data, error }: Response<number> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("アラート数の取得に失敗しました", error);
    return 0;
  }
}

interface GetAlertCountByLabsPayload {
  tenant_id: number;
  lab_ids: number[];
}

export async function getAlertCountByLabs(
  payload: GetAlertCountByLabsPayload,
): Promise<Map<number, number>> {
  try {
    const res = await fetch(ENDPOINT.alert.getAlertsCountByLabs, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const { data, error }: Response<Record<string, number>> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    const map = new Map<number, number>();
    for (const [key, count] of Object.entries(data ?? {})) {
      map.set(Number(key), count ?? 0);
    }

    return map;
  } catch (error) {
    errorMessage("アラート数の取得に失敗しました", error);
    return new Map();
  }
}

export interface HandleAlertPayload {
  category: string;
  lab_id: number;
  tenant_id: number;
  reagent_id?: number;
  reagent_group_id?: number;
}

export async function handleAlert(payload: HandleAlertPayload) {
  try {
    const res = await fetch(ENDPOINT.alert.handleAlert, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (res.status === 204) {
      return;
    }

    if (!res.ok) {
      const { error }: Response<null> = await res.json();
      console.log(error);
      throw new Error(error ?? "Server Error");
    }
  } catch (error) {
    errorMessage("アラートの変更に失敗しました", error);
  }
}

interface GetListByIdsPayload {
  ids: number[];
}

export async function getReagentListByIds(
  payload: GetListByIdsPayload,
): Promise<Reagent[]> {
  try {
    const res = await fetch(ENDPOINT.alert.getReagentListByIds, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    const { data, error }: Response<Reagent[]> = await res.json();

    if (!res.ok) {
      throw new Error(error ?? "Server Error");
    }

    return data;
  } catch (error) {
    errorMessage("試薬リストの取得に失敗しました", error);
    return [];
  }
}

interface handleHiddenAlertPayload {
  alertId: number;
}

export async function handleHiddenAlert(payload: handleHiddenAlertPayload) {
  try {
    const res = await fetch(ENDPOINT.alert.handleHiddenAlert, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (res.status === 204) {
      return;
    }

    if (!res.ok) {
      const { error }: Response<null> = await res.json();
      console.log(error);
      throw new Error(error ?? "Server Error");
    }
  } catch (error) {
    errorMessage("アラートの変更に失敗しました", error);
  }
}
